// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import TurksAndCaicosIslands from '../_raw/flag/icon_flag_turks_and_caicos_islands.png';

export default () => <img src={TurksAndCaicosIslands} alt="TurksAndCaicosIslands" />;
